import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-resumen-resagado',
  templateUrl: './lista.component.html'
})

export class CajaComponent{
  tamano = document.body.clientHeight;
  datos = [];
  cargando = false;

}